<body>
  <div class="grid-overlay">
    <app-page-header>
      @if (canManageCreditCards()) {
        <button class="header-action-btn" (click)="openPopUp({}, true)">{{ 'customerCards.createCard' | translate }}</button>
      }
    </app-page-header>
    <div class="reports-data">

      <div style="padding-top: 2em;">
        <mat-table [dataSource]="dataSource" matSort  >

          <ng-container matColumnDef="maskCreditCard">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerCards.cardNumber' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="maskCreditCard"> {{row.maskCreditCard}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="expMonthCreditCard">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerCards.provider' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="expMonthCreditCard"> {{row.expMonthCreditCard}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="expiration">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerCards.expiration' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="expiration"> {{row.expiration}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nameHolderCreditCard">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerCards.name' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="nameHolderCreditCard"> {{row.nameHolderCreditCard}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="billingAddress">
            <mat-header-cell *matHeaderCellDef> {{ 'customerCards.billingAddress' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="billingAddress">
              @if (row.billingAddress) {
                <div class="billing-address">
                  <span class="billing-address__line" [title]="row.billingAddress.address">{{ row.billingAddress.address }}</span>
                  <span class="billing-address__detail" [title]="formatAddressDetail(row.billingAddress)">{{ formatAddressDetail(row.billingAddress) }}</span>
                </div>
              } @else {
                <div class="no-address">
                  <span class="chip-warning">{{ 'customerCards.noAddress' | translate }}</span>
                  @if (canSetBillingAddress()) {
                    <button type="button" class="add-address-link" (click)="goToBillingAddress(row)">
                      {{ 'customerCards.addAddress' | translate }}
                    </button>
                  }
                </div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerCards.creationDate' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="createdAt"> {{row.createdAt}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerCards.actions' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="estatus">
              @if (canManageCreditCards() || canSetBillingAddress()) {
                <button mat-icon-button [matMenuTriggerFor]="msgMenu" (click)="$event.stopPropagation()" class="hidden-on-open">
                  <mat-icon class="text-muted">more_vert</mat-icon>
                </button>
              }
              <mat-menu class="billing-menu-panel" style="width: 200px;" #msgMenu="matMenu">
                <!--button mat-menu-item (click)="openPopUp(row)"  class="menu_report"><img src="../assets/icons/update.svg">  Actualizar </button-->
                @if (canSetBillingAddress()) {
                  <button mat-menu-item (click)="goToBillingAddress(row)" class="menu_report menu-item-nowrap">
                    <img src="../assets/icons/update.svg">  {{ (row.billingAddress ? 'customerCards.editAddress' : 'customerCards.addBillingAddress') | translate }}
                  </button>
                }
                @if (canManageCreditCards()) {
                  <button mat-menu-item (click)="deleteItem(row)"  class="menu_report"><img src="../assets/icons/toggle.svg">  {{ 'customerCards.delete' | translate }} </button>
                }
                <!-- <button *ngIf="hasPermission('tdc.delete')" mat-menu-item (click)="deleteItem(row)"><mat-icon>delete</mat-icon> Cambiar estado  </button> -->
              </mat-menu>
            </mat-cell>
          </ng-container>


          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" >
          </mat-row>
        </mat-table>
        <!-- <mat-paginator showFirstLastButtons
        [length]="tableService.pager.totalEntities"
        [pageIndex]="tableService.pager.pageIndex"
        [pageSize]="tableService.pager.pageSize"
        [pageSizeOptions]="[20, 50, 100]"
        (page)="list($event)">
      </mat-paginator>   -->
    </div>

  </div>

  <div class="options-buttons">
    <button class="back-btn" (click)="goBack()" >{{ 'customerCards.back' | translate }}</button>
  </div>

</div>
</body>
